import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import { fetchDepartments, fetchDesignations } from "./helpers";
import { CompanyInfoValidationSchema } from "./validations";
import LoadingSpinner from "../../Components/spinner";
import { useNavigate, useParams, useLocation } from "react-router-dom";
const CompanyInformation = ({ formikRef, empData, submitEntireForm }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const fromProfile = location.state?.fromProfile;
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);

  const formik = useFormik({
    initialValues: {
      department_id: empData.department_id || "",
      designation_id: empData.designation_id || "",
      basic_salary: empData.FinancialInfo?.basic_salary || "",
      gross_salary: empData.FinancialInfo?.gross_salary || "",
      hourly_rate: empData.FinancialInfo?.hourly_rate || "",
      bank_account_title: empData.FinancialInfo?.bank_account_title || "",
      IBAN: empData.FinancialInfo?.IBAN || "",
    },
    validationSchema: CompanyInfoValidationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const FinancialInfo = {
          basic_salary: values.basic_salary,
          gross_salary: values.gross_salary,
          hourly_rate: values.hourly_rate,
          bank_account_title: values.bank_account_title,
          IBAN: values.IBAN,
        };
        const data = {
          FinancialInfo: FinancialInfo,
          department_id: values.department_id,
          designation_id: values.designation_id,
        };
        await submitEntireForm(data);
      } catch (error) {
        console.log("Error Upon form submition", error);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    fetchDesignations(setDesignations);
    fetchDepartments(setDepartments);
  }, []);

  useEffect(() => {
    formikRef.current.companyInfo = formik;
  }, [formik]);
  return (
    <div>
      <Form>
        <Form.Group className="mb-3">
          <Row className="g-3">
            {/* Department Field */}
            <Col md={6}>
              <Form.Label>Department</Form.Label>
              <Form.Select
                className="bg-dark text-light border-light input-placeholder-light"
                data-testid="department"
                aria-label="Select Department"
                {...formik.getFieldProps("department_id")}
                isInvalid={
                  formik.touched.department_id && !!formik.errors.department_id
                }
              >
                <option value="">Select Department</option>
                {departments?.map((dep) => (
                  <option key={dep.id} value={dep.id}>
                    {dep.name}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {formik.errors.department_id}
              </Form.Control.Feedback>
            </Col>
            {/* Designation Field */}
            <Col md={6}>
              <Form.Label>Designation</Form.Label>
              <Form.Select
                type="text"
                data-testid="designation"
                className="bg-dark text-light border-light input-placeholder-light"
                placeholder="Enter Designation"
                {...formik.getFieldProps("designation_id")}
                isInvalid={
                  formik.touched.designation_id &&
                  !!formik.errors.designation_id
                }
              >
                <option value="">Select Designation</option>
                {designations?.map((des) => (
                  <option key={des.id} value={des.id}>
                    {des.title}
                  </option>
                ))}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {formik.errors.designation_id}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <h2 className="mt-4 mb-4">Financial Info</h2>
          {/* Basic Salary Field */}
          <Row className="g-3">
            <Col md={4}>
              <Form.Label>Basic Salary</Form.Label>
              <Form.Control
                type="number"
                data-testid="basicSalary"
                className="bg-dark text-light border-light input-placeholder-light"
                placeholder="Enter Basic Salary"
                {...formik.getFieldProps("basic_salary")}
                isInvalid={
                  formik.touched.basic_salary && !!formik.errors.basic_salary
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.basic_salary}
              </Form.Control.Feedback>
            </Col>
            {/* Gross Salary Field */}
            <Col md={4}>
              <Form.Label>Gross Salary</Form.Label>
              <Form.Control
                type="number"
                data-testid="grossSalary"
                className="bg-dark text-light border-light input-placeholder-light"
                placeholder="Enter Gross Salary"
                {...formik.getFieldProps("gross_salary")}
                isInvalid={
                  formik.touched.gross_salary && !!formik.errors.gross_salary
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.gross_salary}
              </Form.Control.Feedback>
            </Col>
            {/* Per Hourly Rate Field */}
            <Col md={4}>
              <Form.Label>Per Hourly Rate</Form.Label>
              <Form.Control
                type="number"
                data-testid="perHourRate"
                className="bg-dark text-light border-light input-placeholder-light"
                placeholder="Enter Per Hourly Rate"
                {...formik.getFieldProps("hourly_rate")}
                isInvalid={
                  formik.touched.hourly_rate && !!formik.errors.hourly_rate
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.hourly_rate}
              </Form.Control.Feedback>
            </Col>
          </Row>
          {/* Bank Account Title */}
          <Row className="g-3 mt-3">
            <Col md={6}>
              <Form.Label>Bank Account Title</Form.Label>
              <Form.Control
                type="text"
                data-testid="BAT"
                className="bg-dark text-light border-light input-placeholder-light"
                placeholder="Enter Bank Account Title"
                {...formik.getFieldProps("bank_account_title")}
                isInvalid={
                  formik.touched.bank_account_title &&
                  !!formik.errors.bank_account_title
                }
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.bank_account_title}
              </Form.Control.Feedback>
            </Col>
            {/* IBAN Field */}
            <Col md={6}>
              <Form.Label>IBAN</Form.Label>
              <Form.Control
                type="text"
                data-testid="IBAN"
                className="bg-dark text-light border-light input-placeholder-light"
                placeholder="Enter IBAN"
                {...formik.getFieldProps("IBAN")}
                isInvalid={formik.touched.IBAN && !!formik.errors.IBAN}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.IBAN}
              </Form.Control.Feedback>
            </Col>
          </Row>
          <div className="container-fluid mt-4" data-testid="loading-spinner-lg">
            <div className="d-flex justify-content-end">
              {loading && <LoadingSpinner size="lg" />}
              <Button
                variant="danger"
                onClick={() => {
                  if (fromProfile && id) {
                    navigate(`/EmployeeProfile/${id}`);
                  } else {
                    navigate("/employees");
                  }
                }}
                className="mb-4 ml-2"
              >
                Exit
              </Button>
              <Button
                variant="success"
                onClick={() => {
                  formik.handleSubmit();
                }}
                className="mb-4 ml-2"
              >
                Save Company Info
              </Button>
            </div>
          </div>
        </Form.Group>
      </Form>
    </div>
  );
};
export default CompanyInformation;
